import {Other} from "../../../../DataBase/data";
import Modal from "../modal/modal";
import {useState} from "react";
import photo from "../../../../assets/photo_2022-11-05_16-17-44.jpg"


const Drinkss = ({other, s}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currItemIdx, setCurrItemIdx] = useState(0);

    const toggle = (itemId) => {
        setCurrItemIdx(itemId);
        setIsOpen(p => !p);
        console.log(itemId)
    }

    const nextButton = () => {
        if (currItemIdx !== 7) {
            setCurrItemIdx(currItemIdx + 1)
        }
    }

    const prevButton = () => {
        if (currItemIdx !== 0) {
            setCurrItemIdx(currItemIdx - 1)
        }
    }

    return (
        <>
            <h1 className="categoryName" id={'ichimliklar'}> </h1>
            {
                other.map((salads, index) => (
                    salads.category === " " ?
                        <div key={index} className={'menu_content_block_card'} onClick={() => {
                            toggle(index)
                        }}>
                            <div key={index} className="menu_content_block_card_header">
                                <div className="menu_content_block_card_header_img">
                                    <img src={salads.image} alt=""/></div>
                            </div>
                            <div className="menu_content_block_card_footer">
                                <div className="menu_content_block_card_footer_title">{salads.name}</div>
                                <div className="menu_content_block_card_footer_price">{salads.price}</div>
                            </div>
                        </div> : " "
                ))
            }
            <Modal isOpen={isOpen} next={nextButton} prev={prevButton} toggle={toggle} item={Other[currItemIdx]}/>
        </>
    )
}

export default Drinkss
